type Props = { fill?: string };

const MessageIcon = ({ fill }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M1.5 5.61523V10.25H10.5V5.66211L12 4.83691V11C12 11.4148 11.664 11.75 11.25 11.75H0.75C0.336 11.75 0 11.4148 0 11V4.77148L1.5 5.61523ZM11.25 1.25C11.7 1.25 12 1.55 12 2V3.125L6 6.4248L0 3.0498V2C0 1.55 0.3 1.25 0.75 1.25H11.25Z"
        fill="white"
      />
    </svg>
  );
};

export default MessageIcon;
